import { api } from "./api";

/** TYPE & INTERFACE **/
export interface UserCustomSetting {
  useScaleBar: boolean;
  useMagnificationBar: boolean;
  useCaptureButton: boolean;
  useViewerRotationSlider: boolean;
  useGammaSlider: boolean;
  useViewerThumbnail: boolean;
  useAnnotation: boolean;
  useICCButton: boolean;
  userGammaValue: number;
  useInvertedZoom: boolean;
}

/** APIs **/
export const getLoginUser = async () => {
  try {
    const { data } = await api().get("/login-user");
    return data.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const getAuthorUserList = async () => {
  try {
    const { data } = await api().get("/author-user/list");
    return data.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const getUserProfileImg = async (filename: string) => {
  try {
    const { data } = await api().get(`/profile-img/${filename}`, {
      headers: {
        "Content-Type": "image/png",
      },
      responseType: "blob",
    });

    return data;
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const getUserCustomSetting = async () => {
  try {
    const { data } = await api().get("/user-custom-setting");
    return data.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const patchUserCustomSetting = async (
  userCustomSetting: UserCustomSetting
) => {
  try {
    const body = { ...userCustomSetting };
    const { data } = await api().patch("/user-custom-setting", body);
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const postProfileImage = async (formData: FormData) => {
  try {
    const data = await api().post("/profile-img", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (e) {
    console.error("Error uploading files:", e);
    throw e;
  }
};

/**
 * 현재 로그인한 사용자의 저자 셜명 등록 및 수정
 * 
 * @param description 
 * @returns 
 */
export const postAuthorDescription = async (description: string) => {
  try {
    const body = { description };
    await api().post("/author-description", body);
  } catch (e) {
    console.log(e);
    return {};
  }
}

/**
 * 현재 로그인한 사용자의 저자 설명 조회
 * 
 * @returns description
 */
export const getAuthorDescription = async () => {
  try {
    const { data } = await api().get("/author-description");
    return data.data;
  } catch (e) {
    console.log(e);
    return {};
  }
}

export const postVisitLog = async () => {
  try {
    await api().post("/visit-log");
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getVisitTotalCount = async () => {
  try {
    const { data } = await api().get("/visit-log/total-count");
    return data.data;
  } catch (e) {
    console.log(e);
    return 0;
  }
};

export const getVisitDailyCount = async () => {
  try {
    const { data } = await api().get("/visit-log/daily-count");
    return data.data;
  } catch (e) {
    console.log(e);
    return 0;
  }
};

export const changeId = async (newUsername: string, currentPassword: string) => {
  try {
    const body = { newUsername, currentPassword };
    const { data } = await api().post("/user/username", body);
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const changeName = async (name: string) => {
  try {
    const body = { name };
    const { data } = await api().post("/user/name", body);
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const changePassword = async (currentPassword: string, newPassword: string) => {
  try {
    const body = { currentPassword, newPassword };
    const { data } = await api().post("/user/password", body);
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

//최근 본 게시물 조회
export const getMyRecentPosts = async (page?: number, size?: number) => {
  try {
    const params = { page, size };
    const { data } = await api().get("/mypage/recent-posts", { params });
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

//작성한 댓글 조회
export const getMyComments = async (page?: number, size?: number) => {
  try {
    const params = { page, size };
    const { data } = await api().get("/mypage/comments", { params });
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

//작성한 어노테이션 조회
export const getMyAnnotations = async (page?: number, size?: number) => {
  try {
    const params = { page, size };
    const { data } = await api().get("/mypage/annotations", { params });
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};